export default __webpack_public_path__ + "static/media/bathroom1-before-1920w.c888297d.avif";